export default "__VITE_PUBLIC_ASSET__42529552__"